module.exports = __webpack_public_path__ + "static/media/Price4999Ins.5c58cdde.svg";